import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { HandleErrorService } from './HandleErrorService';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';


@Injectable()
export class GlobalInterceptor implements HttpInterceptor {
  constructor(public errService:HandleErrorService) {}
  intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
    let cloneReq:any;
    var isValidUser:any;
      var paramVal = request.params.get('rightsJSON');
      if(paramVal!=undefined && paramVal!=null){
          cloneReq = request.clone({
          params: request.params.delete('rightsJSON')
         
        })
        isValidUser = true;
      }else{
        cloneReq = request;
        isValidUser = true;

      }
      if(isValidUser){
        /*
         // add auth header with jwt if user is logged in and request is to api url
        const currentUser = this.authenticationService.currentUserValue;
        const isLoggedIn = currentUser && currentUser.token;
        const isApiUrl = request.url.startsWith(`${environment.apiURL}`);

        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        }
        */
        return next.handle(cloneReq)
        .pipe(
          catchError((error:any) => {
            
            //return this.errService.handleError(error);
            return throwError(this.errService.handleError(error));
            //return throwError(error);
          }));
      }else{
          alert('user doesnt have rights');
          return throwError("invalid user rights");
      }      
  }
}

